import { useEffect, useState } from 'react';
import apiService from '../../services/apiService';

/**
 * Listas de apoio do menu Escalas para a empresa escolhida: lojas, vendedores e unidades.
 * Mesma origem da aba Tetos: lojas e vendedores do editor de prompts / Revisão de Pontos, e as
 * unidades (com `store_ids`) da listagem de Comunicados. Falha de vendedor ou unidade não derruba a
 * tela: só some o que depende dela.
 */
export default function useLookups(subdomain, user, notify) {
    const [stores, setStores] = useState([]);
    const [salesmen, setSalesmen] = useState([]);
    const [units, setUnits] = useState([]);

    useEffect(() => {
        setStores([]); setSalesmen([]); setUnits([]);
        if (!subdomain) return undefined;
        let vivo = true;
        (async () => {
            try {
                const st = await apiService.promptEditorGetStores(subdomain);
                if (vivo) setStores(Array.isArray(st) ? st : []);
            } catch (e) { if (vivo) notify('Erro ao carregar as lojas', 'error'); }
            try {
                const r = await apiService.pointsSalesmen({ userId: user?.user_id, subdomain });
                if (vivo) setSalesmen(Array.isArray(r?.salesmen) ? r.salesmen : []);
            } catch (e) { /* silencioso: só vendedor depende disso */ }
            try {
                const lst = await apiService.communicationsList({
                    subdomain, types: ['banner'], include_inactive: false, include_expired: false,
                });
                if (vivo) setUnits(Array.isArray(lst?.units) ? lst.units : []);
            } catch (e) { /* silencioso: só unidade depende disso */ }
        })();
        return () => { vivo = false; };
    }, [subdomain, user?.user_id, notify]);

    const nomeLoja = (id) => {
        const s = stores.find((x) => String(x.id) === String(id));
        return s ? (s.display_name || s.name) : `Loja ${id}`;
    };
    const nomeUnidade = (id) => units.find((u) => String(u.id) === String(id))?.label || `Unidade ${id}`;

    return { stores, salesmen, units, nomeLoja, nomeUnidade };
}
